import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

const StyledPaper = styled(Paper)`
  && {
    pointer-events: none;
    border: 1px solid #e5e3d8;
    border-radius: 4px;
    box-shadow: none;
    padding: 18px;
    max-width: 300px;
    word-wrap: break-word;
    color: #434875;
    font-size: 12px;
    line-height: 1.5;
    box-shadow: -2px 3px 14px 0px #0000004a;
  }
`;

const StyledTypography = styled(Typography)`
  && {
    word-wrap: break-word;
    color: #434875;
    font-size: 14px;
    line-height: 1.5;
  }
`;

const StyledSchengen = styled(Typography)`
  && {
    word-wrap: break-word;
    color: #434875;
    font-size: 13px;
    line-height: 1.5;
  }
`;

function MapTooltip(props) {
  const { show, left, top, title, isSchengen } = props;

  return show ? (
    <StyledPaper
      style={{
        position: 'absolute',
        top: isSchengen ? `${top - 100}px` : `${top - 80}px`,
        left: `${left - 30}px`,
      }}
    >
      <StyledTypography variant="title" gutterBottom>
        {title}
      </StyledTypography>
      <StyledSchengen variant="subheading" gutterBottom>
        {isSchengen}
      </StyledSchengen>
    </StyledPaper>
  ) : null;
}

export default MapTooltip;



// WEBPACK FOOTER //
// ./src/maps/MapTooltip.js